export default __webpack_public_path__ + "static/media/catfacts.a5030f6b.png";